import Model from './model';
import { conditionTypes, systemValues } from '../constants';

const getPageComponentName = (value, model) => {
    return model.pageComponents.data.find(component => component.id.value === value);
};

const getMetadataType = (value) => {
    return conditionTypes.find(component => component.value === value);
};

const getValueDeveloperName = (component) => {
    const valueProps = component.valueElementValueBindingReferenceId.data;
    if (valueProps !== null) {
        const assocValue = valueProps[0].properties.find(prop => prop.developerName === 'DeveloperName');
        return assocValue.contentValue;
    }
    return null;
};

/**
 * @description Helper function for generating data sent to draw api
 * for viewing page conditions. This exists because existing page condition tool is a system flow
 * whilst the simple page condition tools are react components that talk directly to the api.
 */
export const generateDummyBoolPageCondition = (condition, model) => {

    const rulepageObjectReferenceId = condition.pageRules[0].left.pageObjectReferenceId;
    let ruleLeftValueReferenceId = null;
    let ruleLeftValueReferenceTypeElementPropertyId = null;
    if (condition.pageRules[0].left.valueElementToReferenceId !== null) {
        ruleLeftValueReferenceId = condition.pageRules[0].left.valueElementToReferenceId.id;
        ruleLeftValueReferenceTypeElementPropertyId = condition.pageRules[0].left.valueElementToReferenceId.typeElementPropertyId;
    }

    const ruleRightValue = condition.pageRules[0].right.valueElementToReferenceId;
    const operationAssignorValue = condition.pageOperations[0].assignment.assignor.valueElementToReferenceId;
    const metadataType = condition.pageOperations[0].assignment.assignee.metadataType;
    const operationObjectReferenceId = condition.pageOperations[0].assignment.assignee.pageObjectReferenceId;

    const rulepageObjectReferenceName = getPageComponentName(rulepageObjectReferenceId, model);
    const ruleLeftValueName = getValueDeveloperName(rulepageObjectReferenceName);
    const operationObjectReferenceName = getPageComponentName(operationObjectReferenceId, model);
    const friendlyMetaTypeName = getMetadataType(metadataType);

    const dummyCondition = {
        "developerName": "PageCondition",
        "externalId": Model.guid(),
        "internalId": Model.guid(),
        "isSelected": false,
        "order": 0,
        "properties": [
            {
                "contentFormat": null,
                "contentType": "ContentList",
                "contentValue": null,
                "developerName": "PageRules",
                "objectData": [
                    {
                        "developerName": "PageRule",
                        "externalId": Model.guid(),
                        "internalId": Model.guid(),
                        "isSelected": false,
                        "order": 0,
                        "properties": [
                            {
                                "contentFormat": null,
                                "contentType": "ContentObject",
                                "contentValue": null,
                                "developerName": "Left",
                                "objectData": [
                                    {
                                        "developerName": "PageObjectReference",
                                        "externalId": Model.guid(),
                                        "internalId": Model.guid(),
                                        "isSelected": false,
                                        "order": 0,
                                        "properties": [
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentString",
                                                "contentValue": rulepageObjectReferenceId,
                                                "developerName": "PageObjectReferenceId",
                                                "objectData": null,
                                                "typeElementId": null,
                                                "typeElementPropertyId": "886d7a4c-35bb-4c85-8640-161c5a812a27"
                                            },
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentString",
                                                "contentValue": "",
                                                "developerName": "TypeElementPropertyId",
                                                "objectData": null,
                                                "typeElementId": null,
                                                "typeElementPropertyId": "40e03948-be16-4dc6-87cc-9cb3d6e635bb"
                                            },
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentString",
                                                "contentValue": "",
                                                "developerName": "PageObjectReferenceDeveloperName",
                                                "objectData": null,
                                                "typeElementId": null,
                                                "typeElementPropertyId": "41ee2566-0d0d-4bfb-aa48-ece644a59de1"
                                            },
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentObject",
                                                "contentValue": "",
                                                "developerName": "ValueElementToReferenceId",
                                                "objectData": [
                                                    {
                                                        "developerName": "ValueElementIdReference",
                                                        "externalId": Model.guid(),
                                                        "internalId": Model.guid(),
                                                        "isSelected": false,
                                                        "order": 0,
                                                        "properties": [
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": ruleLeftValueName,
                                                                "developerName": "DeveloperName",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "c17205f9-e059-418c-9f88-d3d9484d87aa"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementDeveloperName",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "3e1ca4ea-a547-4029-ae79-bac4c8cca142"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementPropertyDeveloperName",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "37e7883e-a6d6-439b-a87b-40aab93a9b8c"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementPropertyTypeElementId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "9ac07ed1-2a80-4fd9-9c33-775d340fe7a1"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "ElementType",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "83ee05f1-5189-4d8d-81d8-bf6284fd93d1"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "20a3956f-1b4c-4c76-a2c5-302c7eee1a16"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "ServiceElementId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "e403e989-781e-4604-9bcb-3b81f70244c8"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "ServiceElementDeveloperName",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "e00fecbe-46c8-4e31-84e6-85167046b0d3"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "ContentBoolean",
                                                                "developerName": "ContentType",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "58d8c4ac-7258-41ec-8811-2754f4e34724"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentBoolean",
                                                                "contentValue": "False",
                                                                "developerName": "IsFixed",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "f6f37cb6-0ddc-4c55-a4f4-68eab0f0cf39"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "Access",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "8b291f28-4c28-4f3c-98de-130ba87bcc7e"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": ruleLeftValueReferenceId,
                                                                "developerName": "Id",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "b69ba467-a105-4f67-83e8-f2dac7716b1d"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": ruleLeftValueReferenceTypeElementPropertyId,
                                                                "developerName": "TypeElementPropertyId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "7e8b2660-75ec-40d3-a77b-34bd93228fa2"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "Command",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "9a7d7c2a-fb37-49e5-a504-16607fd275ca"
                                                            }
                                                        ],
                                                        "typeElementId": "0cae1572-df7a-481e-ac73-74dd08b72b92"
                                                    }
                                                ],
                                                "typeElementId": "0cae1572-df7a-481e-ac73-74dd08b72b92",
                                                "typeElementPropertyId": "55b42aba-b950-4efd-bb87-19e7961cf162"
                                            },
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentString",
                                                "contentValue": "VALUE",
                                                "developerName": "MetadataType",
                                                "objectData": null,
                                                "typeElementId": null,
                                                "typeElementPropertyId": "06c515f5-b2c7-4189-9e5e-d0c256bfbd68"
                                            }
                                        ],
                                        "typeElementId": "9c38e2e7-c1d8-45c6-83e1-9f1833b4709a"
                                    }
                                ],
                                "typeElementId": "9c38e2e7-c1d8-45c6-83e1-9f1833b4709a",
                                "typeElementPropertyId": "0467221a-a7a4-465c-aae9-f02686e87406"
                            },
                            {
                                "contentFormat": null,
                                "contentType": "ContentString",
                                "contentValue": "EQUAL",
                                "developerName": "CriteriaType",
                                "objectData": null,
                                "typeElementId": null,
                                "typeElementPropertyId": "c701bbcd-f37a-46e5-b2ec-3513eaeb1d3d"
                            },
                            {
                                "contentFormat": null,
                                "contentType": "ContentObject",
                                "contentValue": null,
                                "developerName": "Right",
                                "objectData": [
                                    {
                                        "developerName": "PageObjectReference",
                                        "externalId": Model.guid(),
                                        "internalId": Model.guid(),
                                        "isSelected": false,
                                        "order": 0,
                                        "properties": [
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentString",
                                                "contentValue": "",
                                                "developerName": "PageObjectReferenceId",
                                                "objectData": null,
                                                "typeElementId": null,
                                                "typeElementPropertyId": "886d7a4c-35bb-4c85-8640-161c5a812a27"
                                            },
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentString",
                                                "contentValue": "",
                                                "developerName": "TypeElementPropertyId",
                                                "objectData": null,
                                                "typeElementId": null,
                                                "typeElementPropertyId": "40e03948-be16-4dc6-87cc-9cb3d6e635bb"
                                            },
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentString",
                                                "contentValue": "",
                                                "developerName": "PageObjectReferenceDeveloperName",
                                                "objectData": null,
                                                "typeElementId": null,
                                                "typeElementPropertyId": "41ee2566-0d0d-4bfb-aa48-ece644a59de1"
                                            },
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentObject",
                                                "contentValue": null,
                                                "developerName": "ValueElementToReferenceId",
                                                "objectData": [
                                                    {
                                                        "developerName": "ValueElementIdReference",
                                                        "externalId": Model.guid(),
                                                        "internalId": Model.guid(),
                                                        "isSelected": false,
                                                        "order": 0,
                                                        "properties": [
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": ruleRightValue.developerName,
                                                                "developerName": "DeveloperName",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "c17205f9-e059-418c-9f88-d3d9484d87aa"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementDeveloperName",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "3e1ca4ea-a547-4029-ae79-bac4c8cca142"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementPropertyDeveloperName",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "37e7883e-a6d6-439b-a87b-40aab93a9b8c"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementPropertyTypeElementId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "9ac07ed1-2a80-4fd9-9c33-775d340fe7a1"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "ElementType",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "83ee05f1-5189-4d8d-81d8-bf6284fd93d1"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "20a3956f-1b4c-4c76-a2c5-302c7eee1a16"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "ServiceElementId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "e403e989-781e-4604-9bcb-3b81f70244c8"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "ServiceElementDeveloperName",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "e00fecbe-46c8-4e31-84e6-85167046b0d3"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "ContentBoolean",
                                                                "developerName": "ContentType",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "58d8c4ac-7258-41ec-8811-2754f4e34724"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentBoolean",
                                                                "contentValue": "False",
                                                                "developerName": "IsFixed",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "f6f37cb6-0ddc-4c55-a4f4-68eab0f0cf39"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "Access",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "8b291f28-4c28-4f3c-98de-130ba87bcc7e"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": ruleRightValue.id,
                                                                "developerName": "Id",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "b69ba467-a105-4f67-83e8-f2dac7716b1d"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementPropertyId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "7e8b2660-75ec-40d3-a77b-34bd93228fa2"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "Command",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "9a7d7c2a-fb37-49e5-a504-16607fd275ca"
                                                            }
                                                        ],
                                                        "typeElementId": "0cae1572-df7a-481e-ac73-74dd08b72b92"
                                                    }
                                                ],
                                                "typeElementId": "0cae1572-df7a-481e-ac73-74dd08b72b92",
                                                "typeElementPropertyId": "55b42aba-b950-4efd-bb87-19e7961cf162"
                                            },
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentString",
                                                "contentValue": "VALUE",
                                                "developerName": "MetadataType",
                                                "objectData": null,
                                                "typeElementId": null,
                                                "typeElementPropertyId": "06c515f5-b2c7-4189-9e5e-d0c256bfbd68"
                                            }
                                        ],
                                        "typeElementId": "9c38e2e7-c1d8-45c6-83e1-9f1833b4709a"
                                    }
                                ],
                                "typeElementId": "9c38e2e7-c1d8-45c6-83e1-9f1833b4709a",
                                "typeElementPropertyId": "fb2ddb2a-acbe-4ad3-bf3f-4db9366ad240"
                            },
                            {
                                "contentFormat": null,
                                "contentType": "ContentString",
                                "contentValue": `the [${rulepageObjectReferenceName.developerName.value}] Component is EQUAL TO the [${ruleRightValue.developerName}] Value.`,
                                "developerName": "GeneratedSummary",
                                "objectData": null,
                                "typeElementId": null,
                                "typeElementPropertyId": "0d08405c-f428-4e42-bf50-951e88400268"
                            }
                        ],
                        "typeElementId": "ece1cf58-db8e-4fc5-b5db-4fa2abe72a6e"
                    }
                ],
                "typeElementId": "ece1cf58-db8e-4fc5-b5db-4fa2abe72a6e",
                "typeElementPropertyId": "b3279718-cff7-4a28-ba34-a1594f797a67"
            },
            {
                "contentFormat": null,
                "contentType": "ContentString",
                "contentValue": "AND",
                "developerName": "ComparisonType",
                "objectData": null,
                "typeElementId": null,
                "typeElementPropertyId": "e15b1b2b-fd86-4c06-a9a0-af751a932521"
            },
            {
                "contentFormat": null,
                "contentType": "ContentList",
                "contentValue": null,
                "developerName": "PageOperations",
                "objectData": [
                    {
                        "developerName": "PageOperation",
                        "externalId": Model.guid(),
                        "internalId": Model.guid(),
                        "isSelected": false,
                        "order": 0,
                        "properties": [
                            {
                                "contentFormat": null,
                                "contentType": "ContentObject",
                                "contentValue": null,
                                "developerName": "Assignment",
                                "objectData": [
                                    {
                                        "developerName": "PageOperationAssignment",
                                        "externalId": Model.guid(),
                                        "internalId": Model.guid(),
                                        "isSelected": false,
                                        "order": 0,
                                        "properties": [
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentObject",
                                                "contentValue": null,
                                                "developerName": "Assignee",
                                                "objectData": [
                                                    {
                                                        "developerName": "PageObjectReference",
                                                        "externalId": Model.guid(),
                                                        "internalId": Model.guid(),
                                                        "isSelected": false,
                                                        "order": 0,
                                                        "properties": [
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": operationObjectReferenceId,
                                                                "developerName": "PageObjectReferenceId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "886d7a4c-35bb-4c85-8640-161c5a812a27"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementPropertyId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "40e03948-be16-4dc6-87cc-9cb3d6e635bb"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "PageObjectReferenceDeveloperName",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "41ee2566-0d0d-4bfb-aa48-ece644a59de1"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentObject",
                                                                "contentValue": null,
                                                                "developerName": "ValueElementToReferenceId",
                                                                "objectData": null,
                                                                "typeElementId": "0cae1572-df7a-481e-ac73-74dd08b72b92",
                                                                "typeElementPropertyId": "55b42aba-b950-4efd-bb87-19e7961cf162"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": metadataType,
                                                                "developerName": "MetadataType",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "06c515f5-b2c7-4189-9e5e-d0c256bfbd68"
                                                            }
                                                        ],
                                                        "typeElementId": "9c38e2e7-c1d8-45c6-83e1-9f1833b4709a"
                                                    }
                                                ],
                                                "typeElementId": "9c38e2e7-c1d8-45c6-83e1-9f1833b4709a",
                                                "typeElementPropertyId": "84b976af-5c41-4f27-a677-3516c9635398"
                                            },
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentObject",
                                                "contentValue": null,
                                                "developerName": "Assignor",
                                                "objectData": [
                                                    {
                                                        "developerName": "PageObjectReference",
                                                        "externalId": Model.guid(),
                                                        "internalId": Model.guid(),
                                                        "isSelected": false,
                                                        "order": 0,
                                                        "properties": [
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "PageObjectReferenceId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "886d7a4c-35bb-4c85-8640-161c5a812a27"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementPropertyId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "40e03948-be16-4dc6-87cc-9cb3d6e635bb"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "PageObjectReferenceDeveloperName",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "41ee2566-0d0d-4bfb-aa48-ece644a59de1"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentObject",
                                                                "contentValue": null,
                                                                "developerName": "ValueElementToReferenceId",
                                                                "objectData": [
                                                                    {
                                                                        "developerName": "ValueElementIdReference",
                                                                        "externalId": Model.guid(),
                                                                        "internalId": Model.guid(),
                                                                        "isSelected": false,
                                                                        "order": 0,
                                                                        "properties": [
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": operationAssignorValue.developerName,
                                                                                "developerName": "DeveloperName",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "c17205f9-e059-418c-9f88-d3d9484d87aa"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "TypeElementDeveloperName",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "3e1ca4ea-a547-4029-ae79-bac4c8cca142"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "TypeElementPropertyDeveloperName",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "37e7883e-a6d6-439b-a87b-40aab93a9b8c"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "TypeElementPropertyTypeElementId",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "9ac07ed1-2a80-4fd9-9c33-775d340fe7a1"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "ElementType",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "83ee05f1-5189-4d8d-81d8-bf6284fd93d1"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "TypeElementId",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "20a3956f-1b4c-4c76-a2c5-302c7eee1a16"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "ServiceElementId",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "e403e989-781e-4604-9bcb-3b81f70244c8"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "ServiceElementDeveloperName",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "e00fecbe-46c8-4e31-84e6-85167046b0d3"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "ContentBoolean",
                                                                                "developerName": "ContentType",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "58d8c4ac-7258-41ec-8811-2754f4e34724"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentBoolean",
                                                                                "contentValue": "False",
                                                                                "developerName": "IsFixed",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "f6f37cb6-0ddc-4c55-a4f4-68eab0f0cf39"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "Access",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "8b291f28-4c28-4f3c-98de-130ba87bcc7e"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": operationAssignorValue.id,
                                                                                "developerName": "Id",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "b69ba467-a105-4f67-83e8-f2dac7716b1d"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "TypeElementPropertyId",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "7e8b2660-75ec-40d3-a77b-34bd93228fa2"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "Command",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "9a7d7c2a-fb37-49e5-a504-16607fd275ca"
                                                                            }
                                                                        ],
                                                                        "typeElementId": "0cae1572-df7a-481e-ac73-74dd08b72b92"
                                                                    }
                                                                ],
                                                                "typeElementId": "0cae1572-df7a-481e-ac73-74dd08b72b92",
                                                                "typeElementPropertyId": "55b42aba-b950-4efd-bb87-19e7961cf162"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "VALUE",
                                                                "developerName": "MetadataType",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "06c515f5-b2c7-4189-9e5e-d0c256bfbd68"
                                                            }
                                                        ],
                                                        "typeElementId": "9c38e2e7-c1d8-45c6-83e1-9f1833b4709a"
                                                    }
                                                ],
                                                "typeElementId": "9c38e2e7-c1d8-45c6-83e1-9f1833b4709a",
                                                "typeElementPropertyId": "3e425060-cd2c-49a7-9892-2ba4005d9db8"
                                            }
                                        ],
                                        "typeElementId": "df009616-0d89-4b0e-be63-94ac043d6fe3"
                                    }
                                ],
                                "typeElementId": "df009616-0d89-4b0e-be63-94ac043d6fe3",
                                "typeElementPropertyId": "1a2bc34d-d2a7-4590-a1c6-bd93f4641443"
                            },
                            {
                                "contentFormat": null,
                                "contentType": "ContentObject",
                                "contentValue": null,
                                "developerName": "Filter",
                                "objectData": null,
                                "typeElementId": "46d53697-d815-4a09-98e3-e23f08905c81",
                                "typeElementPropertyId": "bd634f65-f9c6-4bb1-b43c-0e41bafbca5d"
                            },
                            {
                                "contentFormat": null,
                                "contentType": "ContentString",
                                "contentValue": `assign the [${operationAssignorValue.developerName}] Value to the [${operationObjectReferenceName.developerName.value}] Component ${friendlyMetaTypeName.key}.`,
                                "developerName": "GeneratedSummary",
                                "objectData": null,
                                "typeElementId": null,
                                "typeElementPropertyId": "4472eb41-be3f-4d27-b11d-07dee006203e"
                            }
                        ],
                        "typeElementId": "5666334b-6ee6-4120-9ca7-55c43a41dffb"
                    }
                ],
                "typeElementId": "5666334b-6ee6-4120-9ca7-55c43a41dffb",
                "typeElementPropertyId": "c24ab10a-bccd-41c2-8028-ba86d4e2a46a"
            },
            {
                "contentFormat": null,
                "contentType": "ContentString",
                "contentValue": `IF the [${rulepageObjectReferenceName.developerName.value}] Component is EQUAL TO the [${ruleRightValue.developerName}] Value THEN assign the [${operationAssignorValue.developerName}] Value to the [${operationObjectReferenceName.developerName.value}] Component ${friendlyMetaTypeName.key}.`,
                "developerName": "GeneratedSummary",
                "objectData": null,
                "typeElementId": null,
                "typeElementPropertyId": "b35e6563-2204-4796-8986-0b66d8d6a221",
            }
        ],
        "typeElementId": "e2383d33-e2ae-4ffc-82b8-f8dca6b90123"
    };

    return dummyCondition;
};

/**
 * @description Helper function for generating data sent to draw api
 * for viewing page conditions. This exists because existing page condition tool is a system flow
 * whilst the simple page condition tools are react components that talk directly to the api.
 */
export const generateDummyScalarPageCondition = (condition, model, valueComparison) => {
    const rulepageObjectReferenceId = condition.pageRules[0].left.pageObjectReferenceId;
    const rulepageObjectReferenceName = getPageComponentName(rulepageObjectReferenceId, model);
    const operationObjectReferenceId = condition.pageOperations[0].assignment.assignee.pageObjectReferenceId;
    const operationObjectReferenceName = getPageComponentName(operationObjectReferenceId, model);
    const operationAssignorValue = condition.pageOperations[0].assignment.assignor.valueElementToReferenceId;
    const metadataType = condition.pageOperations[0].assignment.assignee.metadataType;
    const friendlyMetaTypeName = getMetadataType(metadataType);
    const criteria = condition.pageRules[0].criteriaType;
    let comparisonName = valueComparison;
    let comparisonContentType = 'Boolean';
    if (valueComparison.valueMeta) {
        comparisonContentType = valueComparison.valueMeta;
    }
    if (valueComparison === systemValues.TRUE.id) {
        comparisonName = systemValues.TRUE.developerName;
    }
    if (valueComparison === systemValues.FALSE.id) {
        comparisonName = systemValues.FALSE.developerName;
    }
    if (valueComparison && typeof valueComparison === 'object') {
        comparisonName = valueComparison.developerName;
    }
    let comparisonId = valueComparison;
    if (valueComparison && typeof valueComparison === 'object') {
        comparisonId = valueComparison.id;
    }

    const dummyCondition = {
        "developerName": "PageCondition",
        "externalId": Model.guid(),
        "internalId": Model.guid(),
        "isSelected": false,
        "order": 0,
        "properties": [
            {
                "contentFormat": null,
                "contentType": "ContentList",
                "contentValue": null,
                "developerName": "PageRules",
                "objectData": [
                    {
                        "developerName": "PageRule",
                        "externalId": Model.guid(),
                        "internalId": Model.guid(),
                        "isSelected": false,
                        "order": 0,
                        "properties": [
                            {
                                "contentFormat": null,
                                "contentType": "ContentObject",
                                "contentValue": null,
                                "developerName": "Left",
                                "objectData": [
                                    {
                                        "developerName": "PageObjectReference",
                                        "externalId": Model.guid(),
                                        "internalId": Model.guid(),
                                        "isSelected": false,
                                        "order": 0,
                                        "properties": [
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentString",
                                                "contentValue": rulepageObjectReferenceId,
                                                "developerName": "PageObjectReferenceId",
                                                "objectData": null,
                                                "typeElementId": null,
                                                "typeElementPropertyId": "886d7a4c-35bb-4c85-8640-161c5a812a27"
                                            },
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentString",
                                                "contentValue": "",
                                                "developerName": "TypeElementPropertyId",
                                                "objectData": null,
                                                "typeElementId": null,
                                                "typeElementPropertyId": "40e03948-be16-4dc6-87cc-9cb3d6e635bb"
                                            },
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentString",
                                                "contentValue": "",
                                                "developerName": "PageObjectReferenceDeveloperName",
                                                "objectData": null,
                                                "typeElementId": null,
                                                "typeElementPropertyId": "41ee2566-0d0d-4bfb-aa48-ece644a59de1"
                                            },
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentString",
                                                "contentValue": "VALUE",
                                                "developerName": "MetadataType",
                                                "objectData": null,
                                                "typeElementId": null,
                                                "typeElementPropertyId": "06c515f5-b2c7-4189-9e5e-d0c256bfbd68"
                                            }
                                        ],
                                        "typeElementId": "9c38e2e7-c1d8-45c6-83e1-9f1833b4709a"
                                    }
                                ],
                                "typeElementId": "9c38e2e7-c1d8-45c6-83e1-9f1833b4709a",
                                "typeElementPropertyId": "0467221a-a7a4-465c-aae9-f02686e87406"
                            },
                            {
                                "contentFormat": null,
                                "contentType": "ContentString",
                                "contentValue": criteria,
                                "developerName": "CriteriaType",
                                "objectData": null,
                                "typeElementId": null,
                                "typeElementPropertyId": "c701bbcd-f37a-46e5-b2ec-3513eaeb1d3d"
                            },
                            {
                                "contentFormat": null,
                                "contentType": "ContentObject",
                                "contentValue": null,
                                "developerName": "Right",
                                "objectData": [
                                    {
                                        "developerName": "PageObjectReference",
                                        "externalId": Model.guid(),
                                        "internalId": Model.guid(),
                                        "isSelected": false,
                                        "order": 0,
                                        "properties": [
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentString",
                                                "contentValue": "",
                                                "developerName": "PageObjectReferenceId",
                                                "objectData": null,
                                                "typeElementId": null,
                                                "typeElementPropertyId": "886d7a4c-35bb-4c85-8640-161c5a812a27"
                                            },
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentString",
                                                "contentValue": "",
                                                "developerName": "TypeElementPropertyId",
                                                "objectData": null,
                                                "typeElementId": null,
                                                "typeElementPropertyId": "40e03948-be16-4dc6-87cc-9cb3d6e635bb"
                                            },
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentString",
                                                "contentValue": "",
                                                "developerName": "PageObjectReferenceDeveloperName",
                                                "objectData": null,
                                                "typeElementId": null,
                                                "typeElementPropertyId": "41ee2566-0d0d-4bfb-aa48-ece644a59de1"
                                            },
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentObject",
                                                "contentValue": null,
                                                "developerName": "ValueElementToReferenceId",
                                                "objectData": [
                                                    {
                                                        "developerName": "ValueElementIdReference",
                                                        "externalId": Model.guid(),
                                                        "internalId": Model.guid(),
                                                        "isSelected": false,
                                                        "order": 0,
                                                        "properties": [
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": comparisonName,
                                                                "developerName": "DeveloperName",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "c17205f9-e059-418c-9f88-d3d9484d87aa"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementDeveloperName",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "3e1ca4ea-a547-4029-ae79-bac4c8cca142"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementPropertyDeveloperName",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "37e7883e-a6d6-439b-a87b-40aab93a9b8c"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementPropertyTypeElementId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "9ac07ed1-2a80-4fd9-9c33-775d340fe7a1"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "ElementType",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "83ee05f1-5189-4d8d-81d8-bf6284fd93d1"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "20a3956f-1b4c-4c76-a2c5-302c7eee1a16"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "ServiceElementId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "e403e989-781e-4604-9bcb-3b81f70244c8"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "ServiceElementDeveloperName",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "e00fecbe-46c8-4e31-84e6-85167046b0d3"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": comparisonContentType,
                                                                "developerName": "ContentType",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "58d8c4ac-7258-41ec-8811-2754f4e34724"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentBoolean",
                                                                "contentValue": "False",
                                                                "developerName": "IsFixed",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "f6f37cb6-0ddc-4c55-a4f4-68eab0f0cf39"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "Access",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "8b291f28-4c28-4f3c-98de-130ba87bcc7e"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": comparisonId,
                                                                "developerName": "Id",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "b69ba467-a105-4f67-83e8-f2dac7716b1d"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementPropertyId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "7e8b2660-75ec-40d3-a77b-34bd93228fa2"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "Command",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "9a7d7c2a-fb37-49e5-a504-16607fd275ca"
                                                            }
                                                        ],
                                                        "typeElementId": "0cae1572-df7a-481e-ac73-74dd08b72b92"
                                                    }
                                                ],
                                                "typeElementId": "0cae1572-df7a-481e-ac73-74dd08b72b92",
                                                "typeElementPropertyId": "55b42aba-b950-4efd-bb87-19e7961cf162"
                                            },
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentString",
                                                "contentValue": "VALUE",
                                                "developerName": "MetadataType",
                                                "objectData": null,
                                                "typeElementId": null,
                                                "typeElementPropertyId": "06c515f5-b2c7-4189-9e5e-d0c256bfbd68"
                                            }
                                        ],
                                        "typeElementId": "9c38e2e7-c1d8-45c6-83e1-9f1833b4709a"
                                    }
                                ],
                                "typeElementId": "9c38e2e7-c1d8-45c6-83e1-9f1833b4709a",
                                "typeElementPropertyId": "fb2ddb2a-acbe-4ad3-bf3f-4db9366ad240"
                            },
                            {
                                "contentFormat": null,
                                "contentType": "ContentString",
                                "contentValue": `the [${rulepageObjectReferenceName.developerName.value}] Component is ${criteria} the [${comparisonName}] Value.`,
                                "developerName": "GeneratedSummary",
                                "objectData": null,
                                "typeElementId": null,
                                "typeElementPropertyId": "0d08405c-f428-4e42-bf50-951e88400268"
                            }
                        ],
                        "typeElementId": "ece1cf58-db8e-4fc5-b5db-4fa2abe72a6e"
                    }
                ],
                "typeElementId": "ece1cf58-db8e-4fc5-b5db-4fa2abe72a6e",
                "typeElementPropertyId": "b3279718-cff7-4a28-ba34-a1594f797a67"
            },
            {
                "contentFormat": null,
                "contentType": "ContentString",
                "contentValue": "AND",
                "developerName": "ComparisonType",
                "objectData": null,
                "typeElementId": null,
                "typeElementPropertyId": "e15b1b2b-fd86-4c06-a9a0-af751a932521"
            },
            {
                "contentFormat": null,
                "contentType": "ContentList",
                "contentValue": null,
                "developerName": "PageOperations",
                "objectData": [
                    {
                        "developerName": "PageOperation",
                        "externalId": Model.guid(),
                        "internalId": Model.guid(),
                        "isSelected": false,
                        "order": 0,
                        "properties": [
                            {
                                "contentFormat": null,
                                "contentType": "ContentObject",
                                "contentValue": null,
                                "developerName": "Assignment",
                                "objectData": [
                                    {
                                        "developerName": "PageOperationAssignment",
                                        "externalId": Model.guid(),
                                        "internalId": Model.guid(),
                                        "isSelected": false,
                                        "order": 0,
                                        "properties": [
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentObject",
                                                "contentValue": null,
                                                "developerName": "Assignee",
                                                "objectData": [
                                                    {
                                                        "developerName": "PageObjectReference",
                                                        "externalId": Model.guid(),
                                                        "internalId": Model.guid(),
                                                        "isSelected": false,
                                                        "order": 0,
                                                        "properties": [
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": operationObjectReferenceId,
                                                                "developerName": "PageObjectReferenceId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "886d7a4c-35bb-4c85-8640-161c5a812a27"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementPropertyId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "40e03948-be16-4dc6-87cc-9cb3d6e635bb"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "PageObjectReferenceDeveloperName",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "41ee2566-0d0d-4bfb-aa48-ece644a59de1"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentObject",
                                                                "contentValue": null,
                                                                "developerName": "ValueElementToReferenceId",
                                                                "objectData": null,
                                                                "typeElementId": "0cae1572-df7a-481e-ac73-74dd08b72b92",
                                                                "typeElementPropertyId": "55b42aba-b950-4efd-bb87-19e7961cf162"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": metadataType,
                                                                "developerName": "MetadataType",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "06c515f5-b2c7-4189-9e5e-d0c256bfbd68"
                                                            }
                                                        ],
                                                        "typeElementId": "9c38e2e7-c1d8-45c6-83e1-9f1833b4709a"
                                                    }
                                                ],
                                                "typeElementId": "9c38e2e7-c1d8-45c6-83e1-9f1833b4709a",
                                                "typeElementPropertyId": "84b976af-5c41-4f27-a677-3516c9635398"
                                            },
                                            {
                                                "contentFormat": null,
                                                "contentType": "ContentObject",
                                                "contentValue": null,
                                                "developerName": "Assignor",
                                                "objectData": [
                                                    {
                                                        "developerName": "PageObjectReference",
                                                        "externalId": Model.guid(),
                                                        "internalId": Model.guid(),
                                                        "isSelected": false,
                                                        "order": 0,
                                                        "properties": [
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "PageObjectReferenceId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "886d7a4c-35bb-4c85-8640-161c5a812a27"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "TypeElementPropertyId",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "40e03948-be16-4dc6-87cc-9cb3d6e635bb"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "",
                                                                "developerName": "PageObjectReferenceDeveloperName",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "41ee2566-0d0d-4bfb-aa48-ece644a59de1"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentObject",
                                                                "contentValue": null,
                                                                "developerName": "ValueElementToReferenceId",
                                                                "objectData": [
                                                                    {
                                                                        "developerName": "ValueElementIdReference",
                                                                        "externalId": Model.guid(),
                                                                        "internalId": Model.guid(),
                                                                        "isSelected": false,
                                                                        "order": 0,
                                                                        "properties": [
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": operationAssignorValue.developerName,
                                                                                "developerName": "DeveloperName",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "c17205f9-e059-418c-9f88-d3d9484d87aa"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "TypeElementDeveloperName",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "3e1ca4ea-a547-4029-ae79-bac4c8cca142"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "TypeElementPropertyDeveloperName",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "37e7883e-a6d6-439b-a87b-40aab93a9b8c"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "TypeElementPropertyTypeElementId",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "9ac07ed1-2a80-4fd9-9c33-775d340fe7a1"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "ElementType",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "83ee05f1-5189-4d8d-81d8-bf6284fd93d1"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "TypeElementId",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "20a3956f-1b4c-4c76-a2c5-302c7eee1a16"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "ServiceElementId",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "e403e989-781e-4604-9bcb-3b81f70244c8"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "ServiceElementDeveloperName",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "e00fecbe-46c8-4e31-84e6-85167046b0d3"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "ContentBoolean",
                                                                                "developerName": "ContentType",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "58d8c4ac-7258-41ec-8811-2754f4e34724"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentBoolean",
                                                                                "contentValue": "False",
                                                                                "developerName": "IsFixed",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "f6f37cb6-0ddc-4c55-a4f4-68eab0f0cf39"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "Access",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "8b291f28-4c28-4f3c-98de-130ba87bcc7e"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": operationAssignorValue.id,
                                                                                "developerName": "Id",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "b69ba467-a105-4f67-83e8-f2dac7716b1d"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "TypeElementPropertyId",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "7e8b2660-75ec-40d3-a77b-34bd93228fa2"
                                                                            },
                                                                            {
                                                                                "contentFormat": null,
                                                                                "contentType": "ContentString",
                                                                                "contentValue": "",
                                                                                "developerName": "Command",
                                                                                "objectData": null,
                                                                                "typeElementId": null,
                                                                                "typeElementPropertyId": "9a7d7c2a-fb37-49e5-a504-16607fd275ca"
                                                                            }
                                                                        ],
                                                                        "typeElementId": "0cae1572-df7a-481e-ac73-74dd08b72b92"
                                                                    }
                                                                ],
                                                                "typeElementId": "0cae1572-df7a-481e-ac73-74dd08b72b92",
                                                                "typeElementPropertyId": "55b42aba-b950-4efd-bb87-19e7961cf162"
                                                            },
                                                            {
                                                                "contentFormat": null,
                                                                "contentType": "ContentString",
                                                                "contentValue": "VALUE",
                                                                "developerName": "MetadataType",
                                                                "objectData": null,
                                                                "typeElementId": null,
                                                                "typeElementPropertyId": "06c515f5-b2c7-4189-9e5e-d0c256bfbd68"
                                                            }
                                                        ],
                                                        "typeElementId": "9c38e2e7-c1d8-45c6-83e1-9f1833b4709a"
                                                    }
                                                ],
                                                "typeElementId": "9c38e2e7-c1d8-45c6-83e1-9f1833b4709a",
                                                "typeElementPropertyId": "3e425060-cd2c-49a7-9892-2ba4005d9db8"
                                            }
                                        ],
                                        "typeElementId": "df009616-0d89-4b0e-be63-94ac043d6fe3"
                                    }
                                ],
                                "typeElementId": "df009616-0d89-4b0e-be63-94ac043d6fe3",
                                "typeElementPropertyId": "1a2bc34d-d2a7-4590-a1c6-bd93f4641443"
                            },
                            {
                                "contentFormat": null,
                                "contentType": "ContentObject",
                                "contentValue": null,
                                "developerName": "Filter",
                                "objectData": null,
                                "typeElementId": "46d53697-d815-4a09-98e3-e23f08905c81",
                                "typeElementPropertyId": "bd634f65-f9c6-4bb1-b43c-0e41bafbca5d"
                            },
                            {
                                "contentFormat": null,
                                "contentType": "ContentString",
                                "contentValue": `assign the [${operationAssignorValue.developerName}] Value to the [${operationObjectReferenceName.developerName.value}] Component ${friendlyMetaTypeName.key}.`,
                                "developerName": "GeneratedSummary",
                                "objectData": null,
                                "typeElementId": null,
                                "typeElementPropertyId": "4472eb41-be3f-4d27-b11d-07dee006203e"
                            }
                        ],
                        "typeElementId": "5666334b-6ee6-4120-9ca7-55c43a41dffb"
                    }
                ],
                "typeElementId": "5666334b-6ee6-4120-9ca7-55c43a41dffb",
                "typeElementPropertyId": "c24ab10a-bccd-41c2-8028-ba86d4e2a46a"
            },
            {
                "contentFormat": null,
                "contentType": "ContentString",
                "contentValue": `IF the [${rulepageObjectReferenceName.developerName.value}] Component is ${criteria} the [${comparisonName}] Value THEN assign the [${operationAssignorValue.developerName}] Value to the [${operationObjectReferenceName.developerName.value}] Component ${friendlyMetaTypeName.key}.`,
                "developerName": "GeneratedSummary",
                "objectData": null,
                "typeElementId": null,
                "typeElementPropertyId": "b35e6563-2204-4796-8986-0b66d8d6a221",
            }
        ],
        "typeElementId": "e2383d33-e2ae-4ffc-82b8-f8dca6b90123"
    };

    return dummyCondition;
};
